module.exports = __webpack_public_path__ + "static/media/cash-icon.a81b4f33.svg";